import * as yup from "yup";

const errorMessages = {
  required: "Campo obrigatório",
  mustHaveFields: "Must have fields",
  minOneField: "Minimum of 1 field",
};

/**
 * Certificado SIMPLES — as perguntas continuam sendo campo do formulário.
 *
 * Usado por Certification/Edit/Simple.jsx. A AD-2 inverte a criação e a edição
 * dos certificados COM estrutura de pilar; a tela simples não tem pilar nem
 * seleção de template, então segue coletando `questions` no formulário.
 */
export const certificationSchema = yup.object().shape({
  name: yup.string().required(errorMessages.required),
  questions: yup
    .array()
    .of(
      yup.object().shape({
        id_question_template: yup.number().required(errorMessages.required),
      })
    )
    .required(errorMessages.mustHaveFields)
    .min(1, errorMessages.minOneField),
});

/**
 * EG-42/AD-2 — schema da CRIAÇÃO invertida.
 *
 * As perguntas deixaram de ser campo de formulário: elas são a seleção de
 * templates, que vive em estado do componente e é derivada em estrutura. Um
 * schema que exigisse `questions` deixaria isValid FALSO para sempre e o botão
 * Finalizar desabilitado — foi o defeito achado no teste exploratório.
 *
 * "Tem pelo menos uma pergunta" é checado pela tela, contra a seleção — não cabe
 * no schema porque o dado não está no formulário.
 */
export const certificationCreateSchema = yup.object().shape({
  name: yup.string().required(errorMessages.required),
});

/**
 * EG-42 — schema da EDIÇÃO de certificado.
 *
 * Decisão do TL (2026-08-07): a classificação vem 100% do template, sem exceção.
 * Saíram da tela o rádio "Possui pilares?", o "Número de pilares" e os seletores
 * de pilar — os três descreviam operações que não existem pós-EG-40, e o
 * seletor, além de inerte, nascia vazio.
 *
 * Por isso este schema valida só o que a tela ainda coleta: o nome.
 */
export const certificationEditSchema = yup.object().shape({
  name: yup.string().required(errorMessages.required),
});

// EG-42 — certificationSchemaWithPillars REMOVIDO, junto com a fábrica
// createCertificationSchema e o basicSchema que só existiam para montá-lo.
//
// Ele exigia pillarName e pillarText por pilar, campos que a EG-40 tirou da tela
// quando o nome do pilar passou a vir do catálogo. Era ISSO que mantinha isValid
// falso e o Finalizar desabilitado: a edição de certificado não salvava desde
// então, e o defeito só apareceu no teste exploratório desta story.
//
// O import morto de simpleRegisterSchema saiu no mesmo corte — estava aqui sem
// uso desde antes desta story.
